export const KISA_MIGRATION_LOGIN =
  'RELEASE_TOGGLE_SMART_3848_ENABLE_KISA_MIGRATION';
